import React, { Component } from 'react';
//import SendReceipt from '../components/Remittance/SendReceipt';
import CashMoveReceipt from '../components/CashMove/CashMoveReceipt';
import { getInternalCashMoveData } from '../services/ReportService';

export default class InternalCashMoveReceipt extends Component {

  constructor(){
    super();
    this.language = 'en';
    this.tid = window.location.pathname.split('/')[2];
    this.state = { reportData: null };
    this.isReprintData = false;
    var reprint = window.location.search; 
    if (reprint == '') {
        this.isReprintData = false;
    }
    else {
      this.isReprintData = true;
    }
  }
  componentDidMount() {

    getInternalCashMoveData(this.tid, this.language).then((res) => {
      this.setState({reportData : res.data});
      document.title = "Cash_Move_Receipt_" + res.data.cashMoveTranNum;
    });
  }
  render() {
    return (
      this.state.reportData ?
        <div style={{height:"100vh"}}>
          <CashMoveReceipt result={this.state.reportData} isReprint={this.isReprintData}/>
          <CashMoveReceipt result={this.state.reportData} isReprint={this.isReprintData}/>
        </div>
        : <div></div>
    );
  }
}
